import styled from "styled-components";

const App = styled.div``;

export default App;
